import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';
import Photo from "../components/Photo";
// comps
// import Timeline from "../components/Timeline";
// import TimelinePanel from "../components/TimelinePanel";

const AboutTheWar = () => {
    return (
        <div className={'app--page'}>

            <div className="app--page-content">

                {/*<Timeline plaqueData={orderedByDateDied}
                          showSlider={this.state.currentMode === 'timeline'}
                          currentDayOfWar={currentDayOfWar}
                          onCurrentDaySelect={day => this.setState({ currentDayOfWar: day })}
                          isPlaying={isPlaying}
                />

                <TimelinePanel currentDayOfWar={currentDayOfWar}
                               soldiers={soldierList}
                               isPlaying={isPlaying}
                               onClose={this.onTimelineClose}
                               onDayChange={this.onDayChange}
                               onStart={() => this.setState({ isPlaying: true })}
                               onStop={() => this.setState({ isPlaying: false })}
                               onReset={() => this.setState({ isPlaying: false, currentDayOfWar: 0 })}
                />*/}


                <div className="app--section">
                    <Typography use={'headline3'} tag={'h2'} style={{ textAlign: 'center' }}>
                        Life in the Trenches
                    </Typography>

                    <Photo img={'local-recruits-royal-lancaster-reg.jpg'}
                           caption={'Local Recruits from King\'s Own (Royal Lancaster) Regiment'}/>

                    <Typography use={'body1'}>
                        <p>
                            The Great War was expected to be a relatively short affair and one of great movement. It
                            began
                            dramatically with sweeping advances by German troops through Belgium and France en-route
                            for
                            Paris. However, stalemate and trench warfare soon set in, the front line rippling only
                            slightly
                            back and forth over the years until the spring of 1918.
                        </p>

                        <p>
                            Death was a constant companion to those serving in the line, even when there was no raid
                            or
                            attack. In busy sectors constant shellfire from the enemy brought random death. Many men
                            died on
                            their first day in the trenches from a precisely aimed sniper’s bullet.
                        </p>

                        <Photo img={'battle-of-festubert.jpg'}
                               caption={'The Battle of Festubert: 15th June 1915 was a devastating day for the town of Dalton, at least 6 young men who left the town to serve in WW1 were killed at the battle of Festubert on this day.'}
                               alt={'Battle of Festubert'}/>

                        <p>
                            Men did not spend all their time in the trenches. Typically a Battalion would serve a
                            spell
                            in
                            the front line, followed by a stint spent in support and then in the reserve lines. A
                            period
                            of
                            rest would follow, generally short, before the cycle began again. In reality it would
                            depend
                            on
                            the situation, even ‘at rest’ men might be in the line of fire.
                        </p>

                        <p>
                            As an example a man might expect in a year to spend 70 days in the front line, 30 in
                            nearby
                            support and a further 120 in reserve. Only 70 days might be spent at rest. The amount of
                            leave
                            varied, with perhaps two weeks a year being granted.
                        </p>

                        <p>
                            The daily routine began with morning ’Stand to’. An hour before dawn everyone was roused
                            from
                            sleep by the Company Orderly Officer and Sergeant and ordered to climb up onto the fire
                            step
                            to
                            guard against a dawn raid by the enemy, bayonets fixed. Both sides adopted this stance
                            and
                            even
                            though they knew what to expect many dawn raids occurred. Also they often relieved the
                            tension
                            with machine gun fire, and small arms fire directed into the mist.
                        </p>

                        <p>
                            With stand to over in some areas, rum might be issued to the men, they would then clean
                            their
                            rifle and equipment ready for inspection by officers. Breakfast would now be served and
                            during
                            this, often an unofficial truce would be observed.
                        </p>

                        <p>
                            After breakfast there was inspection by the Company or Platoon Commander and daily
                            chores
                            would
                            be assigned by the NCOs. These chores included;
                        </p>

                        <p>
                            Re-filling sandbags, repair of duck boards, draining work and preparation of latrines,
                            particularly after heavy rain the trenches would fill with muddy water, making life even
                            more
                            miserable and the trench walls were liable to collapse.
                        </p>

                        <p>
                            Given that each side was under constant watch by snipers and look-outs, during daylight
                            movement
                            was restricted until night fell. So once chores were done men had many hours of boredom
                            to
                            fill,
                            writing letters home, snatching sleep, though this was seldom more than a few minutes.
                        </p>

                        <p>
                            With dusk the morning routine of stand to was repeated. Then the trench became a hive of
                            activity-such as fetching rations, and stretcher parties moving the wounded. Patrols
                            would
                            often
                            be sent out into No Man’s Land to repair barbed wire or to listen for information from
                            the
                            enemy
                            line. Sometimes opposing patrols would meet in No Man’s Land. They could then choose to
                            hurry
                            away or engage in hand to hand fighting.
                        </p>

                        <p>
                            Men were relieved from front-line duty at night time too. Weary lines of men carrying
                            picks
                            and
                            shovels corrugated iron, duckboards etc. would move along the communication trenches –
                            it
                            could
                            take several hours.
                        </p>

                        <p>
                            Finally, no overview of trench life can avoid the appalling smell given off from various
                            sources. Rotting carcasses lay around in their thousands, approximately 200,000 were
                            killed
                            on
                            the Somme, many of whom lay in shallow graves. Overflowing latrines gave off a most
                            offensive
                            stench. Men who had not had the luxury of a bath in weeks or months stank of dried
                            sweat.
                            Feet
                            were generally accepted to give off the worst odour. Trenches would also smell of
                            creosol or
                            chloride of lime, used to combat disease and infection. Add to this the smell of
                            cordite,
                            the
                            lingering odour of poison gas, rotting sandbags, stagnant mud, cigarette smoke and
                            cooking
                            odours, yet men grew used to it, while it thoroughly overcame first time visitors to the
                            front.
                        </p>
                    </Typography>
                </div>

                <div className="app--section">

                    <Typography use={'headline3'} tag={'h2'} style={{ textAlign: 'center' }}>
                        ‘Died of disease’. ‘Died from wounds’.
                    </Typography>
                    <Typography use={'body1'}>
                        <p>
                            Not all of the men were killed in action. Sadly even many of those who did not die
                            quickly
                            could
                            suffer for hours out in No Man’s Land because it was too dangerous for stretcher parties
                            to
                            go
                            out for them in daylight.
                        </p>
                        <p>
                            For wounded men, taken behind the lines to Casualty Clearing Stations, the prospects
                            were
                            often
                            not much better. The sheer volume of casualties was overwhelming and the difficulty of
                            transporting them meant many died before getting treatment. The likelihood of infection
                            setting
                            in was very high.
                        </p>
                        <p>
                            Then there was Mustard Gas. It was one of the most lethal chemicals used during the war.
                            It
                            was
                            almost odourless and took twelve hours to take effect. Once in the soil it remained
                            active
                            for
                            several weeks. The skin of victims of mustard gas blistered, the eyes became very sore
                            and
                            they
                            began to vomit. It caused internal and external bleeding and attacked the bronchial
                            tubes,
                            stripping off the mucous membrane. This was extremely painful and most men had to be
                            strapped to
                            their beds. It usually took 4 or 5 weeks for a person to die. One nurse - Vera Brittain
                            wrote -
                        </p>
                        <p>
                            ‘I wish those people who talk about getting on with this war whatever it costs could see
                            the
                            soldiers suffering from mustard gas poisoning. Great mustard coloured blisters, blind
                            eyes,
                            all
                            sticky and stuck together, always fighting for breath, with voices a mere whisper,
                            saying
                            their
                            throats are closing and how they will choke.’
                        </p>
                        <p>
                            The other great killer was the ‘Flu’ epidemic of 1918 which is said to have caused more
                            deaths
                            in the population as a whole than the casualties of the two world wars put together. The
                            infection spread like wildfire amongst the troops in France-and those coming home on
                            leave
                            brought it back with them.
                        </p>
                        <p>
                            The trenches were infested with rats. Gorging themselves on human remains especially the
                            eyes
                            and livers, they could grow to the size of a cat. A single rat couple could produce up
                            to
                            900
                            offspring in a year, spreading infection and contaminating food.
                        </p>
                        <p>
                            Lice were a never ending problem, breeding in the seams of filthy clothing and causing
                            men
                            to
                            itch all the time. Even when clothing was periodically washed and de loused, lice eggs
                            would
                            remain hidden in the seams and within a few hours of being worn the body heat would
                            cause
                            them
                            to hatch.
                        </p>
                        <p>
                            Trench foot is caused by prolonged exposure to damp cold conditions and poor
                            environmental
                            hygiene. The blood vessels constrict in an attempt to keep the feet warm by reducing
                            blood
                            flow
                            to the extremities which can result in tissue and nerve damage. Unlike frost bite it
                            does
                            not
                            require freezing temperatures. Damage can be permanent if left untreated, is most
                            painful
                            and
                            can require amputation. Numbers of casualties dropped later in the war with improved
                            drainage in
                            the trenches but it still affects people in extreme conditions today.
                        </p>
                        <p>
                            Most puzzling, was to read of men who came home to England and then died in 1919, 1920
                            or
                            1921.
                            It is unsettling to think what they must have suffered that allowed them to hang on to
                            life
                            for
                            that long.
                        </p>
                    </Typography>
                </div>
            </div>
        </div>
    )
};

export default AboutTheWar;


// WEBPACK FOOTER //
// ./src/app/pages/AboutTheWar.js